import { render, staticRenderFns } from "./AmenitiesSelection.vue?vue&type=template&id=2db91a13"
import script from "./AmenitiesSelection.vue?vue&type=script&lang=js"
export * from "./AmenitiesSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports